import { render } from "./Mail.vue?vue&type=template&id=5f5b34ee&scoped=true"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"

import "./Mail.vue?vue&type=style&index=0&id=5f5b34ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f5b34ee"

export default script